import { render, staticRenderFns } from "./StageSliders.vue?vue&type=template&id=01d18faa"
import script from "./StageSliders.vue?vue&type=script&lang=js"
export * from "./StageSliders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports